import { IndustriaReadingDtoProps } from "./DTOs/IndustriaReadingDto"

export const IndustriaReadingDtoAdapter = (
  industria: IndustriaReadingDtoProps
) => ({
  id: industria.id,
  descripcion: industria.descripcion,
})
